import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RangeComponent, RangeType } from '../controls/range.component';
import { BaseFieldComponent } from './base-field.component';
import { FieldContainerComponent } from './field-container.component';

@Component({
  selector: 'app-range-field',
  imports: [CommonModule, FieldContainerComponent, RangeComponent],
  template: `
    <app-field-container
      [label]="label"
      [labelClasses]="labelClasses"
      [valueClasses]="valueClasses"
      [control]="control"
    >
      <ng-template #value>
        <app-range
          [control]="control"
          [toControl]="toControl"
          [compact]="compact"
          [label]="controlLabel"
          [placeholder]="placeholder"
          [helpText]="helpText"
          [type]="type"
          [fromLabel]="fromLabel"
          [toLabel]="toLabel"
          [requireBoth]="requireBoth"
          [requirePair]="requirePair"
          [reverseOrder]="reverseOrder"
          [dateLessThanMessage]="dateLessThanMessage"
          [dateGreaterThanMessage]="dateGreaterThanMessage"
          [screenReaderLabel]="controlLabel || label"
          [maxSpanDays]="maxSpanDays"
        ></app-range>
      </ng-template>
    </app-field-container>
  `,
  styles: ``,
})
export class RangeFieldComponent extends BaseFieldComponent {
  @Input()
  toControl: FormControl<any>;

  @Input()
  compact = true;

  @Input()
  type: RangeType = 'Date';

  @Input()
  fromLabel = 'From';

  @Input()
  toLabel = 'To';

  @Input()
  requireBoth = false;

  @Input()
  requirePair = false;

  @Input()
  reverseOrder = false;

  @Input()
  dateLessThanMessage = '';

  @Input()
  dateGreaterThanMessage = '';

  @Input()
  maxSpanDays: number;
}
